import { useMemo } from 'react';

import { useRouter } from 'next/router';

import { omit } from '~/src/common/utils/object';
import {
  ATCSourceFrom,
  CatalogContentLinkQueryParams,
} from '~/src/screens/CatalogContent/ContentScreen/types';

const parse = (query: CatalogContentLinkQueryParams) => {
  const sourceData = omit(query, [
    'category',
    'subcategory',
    'eventSource',
    'categorySlug',
    'slug',
    'type',
  ]);

  const filteredSourceData = Object.fromEntries(
    Object.entries(sourceData).filter(([, value]) => value !== undefined),
  );

  // TODO: Il faudrait faire une meilleure gestion des types et de la reconstruction depuis les params d'url
  return {
    type: query.type,
    detail: {
      ...(Object.keys(filteredSourceData).length > 0 ? filteredSourceData : {}),
    },
  };
};

export const useATCSourceFrom = () => {
  const { query } = useRouter<CatalogContentLinkQueryParams>();
  return useMemo(() => parse(query), [query]);
};

export const useATCSourceFromWithWhitelist = <T extends ATCSourceFrom['type']>(whitelist: T[]) => {
  const { query } = useRouter<CatalogContentLinkQueryParams>();
  return useMemo(() => {
    if (!(whitelist as ATCSourceFrom['type'][]).includes(query.type)) return undefined;
    return parse(query) as Extract<ATCSourceFrom, { type: T }>;
  }, [query, whitelist]);
};

export const useATCSourceFromWithBlacklist = <T extends ATCSourceFrom['type']>(blacklist: T[]) => {
  const { query } = useRouter<CatalogContentLinkQueryParams>();

  return useMemo(() => {
    if ((blacklist as ATCSourceFrom['type'][]).includes(query.type)) return undefined;
    return parse(query) as Extract<ATCSourceFrom, { type: Exclude<ATCSourceFrom['type'], T> }>;
  }, [query, blacklist]);
};
